import { message } from "antd";
import { makeObservable, observable } from "mobx";
import { get, post } from "../../services/request";
import {
  ADD_APPLICATION,
  ADD_PROJECT,
  EDIT_APPLICATION,
  GET_PROJECT_APPS,
  RELOAD_PUBLIC_KEY,
  REMOVE_APPLICATION,
  REMOVE_PROJECT,
  EDIT_PROJECT,
  EDIT_DETAILS,
  GET_DETAILS,
} from "../../services/request/urls";

export interface ProjectInfo {
  id: number;
  name: string;
  publicKey: string;
  des: string;
  sort?: number;
  spellType: string;
  refUrlAppVoList: {
    id: number;
    name: string;
    key: string;
    sort: number;
    display: number;
    backEndUrl: string;
    pictureId: number;
    pictureUrl: string;
    account: string;
  }[];
}
export interface Pagination {
  total: number;
  pageSize: number;
  pageNum: number;
}
class ProjectStore {
  projects?: ProjectInfo[];
  pagination: Pagination = {
    total: 0,
    pageSize: 10,
    pageNum: 1,
  };
  details: string = "";
  constructor() {
    makeObservable(this, {
      projects: observable,
      pagination: observable,
      details: observable,
    });
  }
  setPagination(obj: Pagination) {
    this.pagination = { ...this.pagination, ...obj };
  }
  async addProject(name: string, des: string, otherTagList: string[], industryTag: string, sort?: number) {
    const res = await post(ADD_PROJECT, { name, des, otherTagList, industryTag, sort }, true);
    if (res?.code !== 1) {
      message.error(res?.message ?? "新增失败");
      return;
    }
    message.success("项目新建成功");
    if (this.pagination.total % this.pagination.pageSize === 0) {
      this.setPagination({
        ...this.pagination,
        pageNum: this.pagination.pageNum + 1,
      });
    }
    await this.loadProjects(this.pagination.pageNum, this.pagination.pageSize);
  }

  async editProject(id: number, name: string, des: string, sort?: number) {
    const res = await post(EDIT_PROJECT, { id, name, des, sort }, true);
    if (res?.code !== 1) {
      message.error(res?.message ?? "编辑项目失败");
      return;
    }
    message.success("项目编辑成功");
    if (this.pagination.total % this.pagination.pageSize === 0) {
      this.setPagination({
        ...this.pagination,
        pageNum: this.pagination.pageNum + 1,
      });
    }
    await this.loadProjects(this.pagination.pageNum, this.pagination.pageSize);
  }
  async removeProject(id: number) {
    const res = await post(`${REMOVE_PROJECT}?id=${id}`, { id }, true);

    if (res?.code !== 1) {
      message.error(res?.message ?? "项目删除失败");
      return;
    }
    message.success("项目删除成功");
    if ((this.pagination.total - 1) % this.pagination.pageSize === 0) {
      this.setPagination({
        ...this.pagination,
        pageNum: this.pagination.pageNum - 1,
      });
    }
    this.loadProjects(this.pagination.pageNum, this.pagination.pageSize);
  }

  async removeApplication(id: number, key: string) {
    const res = await post(REMOVE_APPLICATION, { id, key }, true);

    if (res?.code !== 1) {
      message.error(res?.message ?? "应用删除失败");
      return;
    }
    message.success("应用删除成功");

    if (this.pagination.total % this.pagination.pageSize === 0) {
      this.setPagination({
        ...this.pagination,
        pageNum: this.pagination.pageNum,
      });
    }
    await this.loadProjects(this.pagination.pageNum, this.pagination.pageSize);
  }

  async editApplication(formData: FormData) {
    const res = await post(EDIT_APPLICATION, formData, true);
    if (res?.code !== 1) {
      message.error(res?.message ?? "编辑应用失败");
      return;
    }
    message.success("应用编辑成功");
    if (this.pagination.total % this.pagination.pageSize === 0) {
      this.setPagination({
        ...this.pagination,
        pageNum: this.pagination.pageNum,
      });
    }
    await this.loadProjects(this.pagination.pageNum, this.pagination.pageSize);
  }
  async getDetails(key: string) {
    const res = await get(GET_DETAILS + "?key=" + key, null, true);
    if (res?.code !== 1) {
      message.error(res?.message ?? "描述详情获取失败");
      return;
    }
    this.details = res?.data ? res.data : "<p></p>";
  }
  async editDetails(key: string, details: string) {
    const res = await post(EDIT_DETAILS, { key, details }, true);
    if (res?.code !== 1) {
      message.error(res?.message ?? "编辑失败");
      return;
    }
    message.success("应用编辑成功");
    this.details = "";
    if (this.pagination.total % this.pagination.pageSize === 0) {
      this.setPagination({
        ...this.pagination,
        pageNum: this.pagination.pageNum + 1,
      });
    }
    await this.loadProjects(this.pagination.pageNum, this.pagination.pageSize);
  }

  async addApplication(formData: FormData) {
    const res = await post(ADD_APPLICATION, formData, true);
    if (res?.code !== 1) {
      message.error(res?.message ?? "新增应用失败");
      return;
    }
    message.success("应用新增成功");
    if (this.pagination.total % this.pagination.pageSize === 0) {
      this.setPagination({
        ...this.pagination,
        pageNum: this.pagination.pageNum,
      });
    }
    await this.loadProjects(this.pagination.pageNum, this.pagination.pageSize);
  }

  async reloadPublicKey(id: number) {
    const res = await post(RELOAD_PUBLIC_KEY, { id }, true);
    if (res?.code !== 1) {
      message.error(res?.message ?? "重置公钥失败");
      return;
    }

    message.success("重置公钥成功");
    if (this.pagination.total % this.pagination.pageSize === 0) {
      this.setPagination({
        ...this.pagination,
        pageNum: this.pagination.pageNum + 1,
      });
    }
    await this.loadProjects(this.pagination.pageNum, this.pagination.pageSize);
  }

  async loadProjects(pageNo: number = 1, pageSize: number = 10) {
    const res = await get(GET_PROJECT_APPS, { pageNo, pageSize }, true);
    console.log(res);
    if (res?.code !== 1) {
      console.error(res?.message ?? "获取项目应用失败");
      return;
    }
    this.projects = res.rows;
    this.setPagination({
      ...this.pagination,
      total: res.total || 0,
    });
  }
}

export default new ProjectStore();
